export default "__VITE_ASSET__f0b345b3__"